import React, { useEffect } from 'react';
import NProgress from 'nprogress';
import { Box, LinearProgress, CircularProgress } from '@mui/material';

const LoadingScreen = ({ circular = false }) => {
  useEffect(() => {
    NProgress.start();

    return () => {
      NProgress.done();
    };
  }, []);

  return (
    <Box
      sx={{
        alignItems: 'center',
        backgroundColor: 'background.default',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        justifyContent: 'center',
        minHeight: '100%',
        p: 3,
      }}
    >
      {circular ? (
        <Box width={50}>
          <CircularProgress />
        </Box>
      ) : (
        <Box width={400}>
          <LinearProgress />
        </Box>
      )}
    </Box>
  );
};

export default LoadingScreen;
